module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAPFBMVEUAAAAuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzYuLzZ+rgI6Qi5hfxXawSDOAAAAEHRSTlMAXtrxZQ7SxsGenXVYSjATD0fQWgAAAHxJREFUKM+10NsKgCAQBNC11e6Xqf7/XxOCZmPzpWgeZPSArMrnhKoKBUAO0UI+PtcHYHPgdqwO961I61q6MJMAbgySG57kn0ziR3myAV4Sa7KSDDWIliKaq4/QiTIpRu46oI3zIrLMsQU6MRkUV3SQW1Lo68xa9yHJTzkAevUH9DWKmOsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzfw_green.png
// module id = +wZ2
// module chunks = 101